﻿import config from "../config"
const baseUrl = config.base_url + "container_farm_work_arrange/"

export default {
    page: {
        url: baseUrl + "page/{limit}/{page}",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    getFarmWorkSelect: {
        url: baseUrl + "getFarmWorkSelect",
        type: "get",
    },
    listGroup: {
        url: baseUrl + "listByPhenologyIdGroupByIndicator",
        type: "get",
    },
    getComposite: {
        url: baseUrl + "getComposite",
        type: "get",
    },
    saveComposite: {
        url: baseUrl + "saveComposite",
        type: "post",
    },
    toggleFollow: {
        url: baseUrl + "toggleFollow",
        type: "get",
    },
    getFarmWorkArrangeByPhenologyId: {
        url: baseUrl + "getFarmWorkArrangeByPhenologyId",
        type: "get",
    },
} 
